export const startGame = 'https://rf-lykkehjulet-backend-test.azurewebsites.net/startgame/';
export const listGames = 'https://rf-lykkehjulet-backend-test.azurewebsites.net/list';
export const pingBackend = 'https://rf-lykkehjulet-backend-test.azurewebsites.net/ping';
